export class Cities {

  constructor(fields) {
    this.fields = fields;
  }

  mapToStandard() {
    return {
      cities: this.fields?.attributes?.cities
    };
  }
}